import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "./store";
import http from "app/requests/axiosInstance";
import { UserRoles } from "./userSlice";

export interface EmployeesSliceState {
  id: number;
  name: string;
  email: string;
  phone: string;
  shops: any[];
  services: any[];
  invitePending?: boolean;
  role: UserRoles;
  avatar: string;
  availabilities: any[];
  archivedAt: string | null;
  createdAt: string;
  updatedAt: string;
  bio: string;
  invitationToken?: string;
}

const initialState = [] as EmployeesSliceState[];

export const getEmployees = createAsyncThunk(
  "employees/getEmployeesStatus",
  async (_, thunkAPI) => {
    try {
      const { data } = await http.get("/v1/employees");
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// export const createEmployee = createAsyncThunk(
// );

export const updateEmployee = createAsyncThunk(
  "employees/updateEmployeeStatus",
  async (employee: Partial<EmployeesSliceState> | any, thunkAPI) => {
    try {
      // let data, config;
      //
      // if (employee.avatar instanceof FormData) {
      //   // If it's a FormData, send it as the payload
      //   data = employee.avatar;
      //   config = {
      //     headers: {
      //       "Content-Type": "multipart/form-data",
      //     },
      //   };
      // } else {
      //   // If it's not a FormData, send it as JSON
      //   data = employee;
      //   config = {
      //     headers: {
      //       "Content-Type": "application/json",
      //     },
      //   };
      // }

      const response = await http.patch(
        `/v1/employees/${employee.id}`,
        employee,
        // config
      );

      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const disableEmployee = createAsyncThunk(
  "employees/disableEmployeeStatus",
  async (employeeId: number, thunkAPI) => {
    try {
      await http.post(`/v1/disabled_account_service_providers`, {
        user_id: employeeId,
      });
      return employeeId;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const enableEmployee = createAsyncThunk(
  "employees/enableEmployeeStatus",
  async (employeeId: number, thunkAPI) => {
    try {
      await http.delete(`/v1/disabled_account_service_providers/${employeeId}`);
      return employeeId;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// export const deleteEmployee = createAsyncThunk(
// );

export const employeesSlice = createSlice({
  name: "employees",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getEmployees.fulfilled, (state, action) => {
      return action.payload;
    });
    builder.addCase(updateEmployee.fulfilled, (state, action) => {
      const index = state.findIndex(
        (employee) => employee.id === action.payload.id
      );
      state[index] = action.payload;
    });
    builder.addCase(disableEmployee.fulfilled, (state, action) => {
      const index = state.findIndex(
        (employee) => employee.id === action.payload
      );
      if (index !== -1) {
        // remove the employee from the state
        state.splice(index, 1);
      }
    });
    builder.addCase(enableEmployee.fulfilled, (state, action) => {
      const index = state.findIndex(
        (employee) => employee.id === action.payload
      );
      if (index !== -1) {
        state[index] = { ...state[index] };
      }
    });
  },
});

export const selectEmployees = (state: RootState) => state.employees;
export const selectActiveEmployees = (state: RootState) =>
  state.employees.filter((employee: any) => !employee.invitePending);
